/**
 * Master switch for the debug harness.
 *
 * Off by default, everywhere. A user turns it on from their browser devtools —
 * `mqDebug.enable()` (or `localStorage['mq:debug'] = '1'`) then reload — and the
 * harness's UI appears. When off, the overlay chunk is never even fetched (it's
 * lazy-loaded behind this flag), so this costs nothing in the normal app.
 */

const FLAG_KEY = "mq:debug";

function readFlag(): boolean {
    try {
        return localStorage.getItem(FLAG_KEY) === "1";
    } catch {
        // Private mode / storage disabled — treat as off.
        return false;
    }
}

/** Read once at load: toggling requires a reload, which keeps the app's normal
 *  path free of any per-render flag checks. */
export const DEBUG_ENABLED = readFlag();

/**
 * A tiny always-present devtools affordance, so the switch is discoverable
 * without hunting for the key. Costs a few lines in the main bundle; the actual
 * harness stays lazy-loaded behind DEBUG_ENABLED.
 */
export function installDebugConsoleApi() {
    const api = {
        enable() {
            localStorage.setItem(FLAG_KEY, "1");
            location.reload();
        },
        disable() {
            localStorage.removeItem(FLAG_KEY);
            location.reload();
        },
        get enabled() {
            return readFlag();
        },
    };
    try {
        Object.defineProperty(window, "mqDebug", { value: api, configurable: true });
    } catch {
        /* ignore — non-fatal */
    }
}
